// Theme colors based on the design system
export const THEME_COLORS = {
  // Primary colors
  primaryDark: '#182867',      // Dark blue
  primaryBlue: '#2c479e',      // Blue
  accentCyan: '#44c8f5',       // Light blue/cyan
  
  // Status colors
  success: '#00a79d',          // Teal
  error: '#da1f3d',            // Red
  warning: '#faad14',          // Orange/Yellow
  
  // Neutral colors
  gray1: '#bfbfbf',            // Light gray
  gray2: '#f0f0f0',            // Very light gray
  gray3: '#f5f5f5',            // Almost white
  gray4: '#f5fdff',            // Very light blue-white
  
  // Text colors
  textPrimary: '#000000',
  textSecondary: '#8c8c8c',
  textLight: '#ffffff',
} as const;

// Gradients
export const GRADIENTS = {
  primaryBlue: 'linear-gradient(135deg, #182867 0%, #2c479e 100%)',
  success: 'linear-gradient(135deg, #00a79d 0%, #52c41a 100%)',
  error: 'linear-gradient(135deg, #da1f3d 0%, #ff4d4f 100%)',
} as const;

// Common styles
export const COMMON_STYLES = {
  cardBorderRadius: '16px',
  buttonBorderRadius: '12px',
  containerMaxWidth: '1200px',
  cardShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
} as const;
